import { FormControl, FormGroup } from "@angular/forms";

export class SaleMemberRequestBase {
  public isViewAccess: Boolean;
  public isSubmitAccess: Boolean;
  public isAllSaleAccess: Boolean;
  isViewDateApplicable: boolean;
  isSubmitDateApplicable: boolean;
  public isXrayDownloadAccess: Boolean;
  public comments: string;
}

export class SaleMemberRequestModel extends SaleMemberRequestBase {
  public saleId: number;

  static asFormGroup(request: SaleMemberRequestModel) {
    const fg = new FormGroup({
      isViewAccess: new FormControl(request.isViewAccess),
      isSubmitAccess: new FormControl(request.isSubmitAccess),
      isXrayDownloadAccess: new FormControl(request.isXrayDownloadAccess),
      comments: new FormControl(request.comments),
    });
    return fg;
  }
}

export class SaleMemberRequests extends SaleMemberRequestBase {
  public saleMemberRequestId: number;
  public saleMemberStatusId: number;
  public saleMemberStatusName: string;
  public createdDate: any;
  public memberName: string;
  public memberId: number;
  public userId: number;
  public clinic: string;
  public emailAddress: string;
  public mobile: string;
}


export enum SaleMembersStatusIds {
  REQUESTED = 5,
  APPROVED = 3,
  APPROVED_SECOND_STATUS_ID = -2,
  DENIED = 4,
  INVITED = -1
}
